"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvelopeIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.EnvelopeIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement("path", { d: "M3.99951 7.93637V18H19.9995V7.93637L13.2489 14.2811C12.5185 14.8655 11.4806 14.8655 10.7501 14.2811L3.99951 7.93637ZM5.91553 7.00002L12.0008 12.7194L18.086 7.00002H5.91553ZM4 5H20C21.1046 5 22 5.89543 22 7V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V7C2 5.89543 2.89543 5 4 5Z" }), 'EnvelopeIcon');
exports.default = exports.EnvelopeIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW52ZWxvcGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9pY29ucy9FbnZlbG9wZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLG1EQUFnRDtBQUVuQyxRQUFBLFlBQVksR0FBRyxJQUFBLDZCQUFZLEVBQ3RDLHdDQUFNLENBQUMsRUFBQyxxU0FBcVMsR0FBRyxFQUNoVCxjQUFjLENBQ2YsQ0FBQztBQUVGLGtCQUFlLG9CQUFZLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/Envelope.js
// module id = 3487
// module chunks = 25